import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NotificationService } from 'src/app/core/notification.service';
import { StrikeService } from 'src/app/core/strike.service';
import { ApiResponse } from 'src/app/shared/interfaces/api-response';
import { MemberDetails, MemberDetailsPage } from 'src/app/shared/interfaces/member-details';

@Component({
  selector: 'app-strike-register',
  templateUrl: './strike-register.component.html',
  styleUrls: ['./strike-register.component.css']
})
export class StrikeRegisterComponent implements OnInit {
  paramId = '';
  strikeMembers: MemberDetails[] = [];
  page = 0;
  pageCount = 0;
  totalCount = 0;
  filterMembers = '';

  loadingMembers = false;

  constructor(
    private strikes: StrikeService,
    private route: ActivatedRoute,
    private notificationService: NotificationService,
  ) { }

  ngOnInit() {
    this.loadingMembers = true;
    this.paramId = this.route.snapshot.paramMap.get('id') || '';
    
    this.search(this.page)
    
  }

  async search(page: number) {
    this.page = page
    const config = {
      params: {
          page: this.page,
          pageSize: 20,
          filter: this.filterMembers
      }
    };

    const response: MemberDetailsPage = await this.strikes.getStrikeRegistration(this.paramId, config);

    this.loadingMembers = false;
    this.strikeMembers = response.Items;
    this.page = response.Page;
    this.pageCount = response.TotalPages;
    this.totalCount = response.TotalCount;
    
  }

  clearSearch() {
    this.filterMembers = "";
    this.page = 0;
    this.search(this.page);
  }

  async cardSwiped(member: MemberDetails) {
    member.DebitCard = member.DebitCardInfo

    const response: ApiResponse = await this.strikes.updateDebitCard(member);
    
    if (response.success) {
      this.notificationService.displaySuccess("Debit card successfully updated")
    }
    else {
      this.notificationService.displayError("There was an error updating the debit card")
    }
  }

  getStatusColor(status: string | undefined) {
    if (status == 'A' || status == 'N')
        return 'green';
    else {
        return 'red';
    }
  }
}
